var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _g2, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmsG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 181,
    viewBox: "0 0 211 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8669 6.24051C71.084 5.42391 72.702 5.41437 74.6252 5.91205C75.5617 18.3251 87.247 24.9855 105.587 24.9855C123.733 24.9855 135.463 18.4666 136.623 6.30478C137.777 5.70594 140.846 5.38434 142.115 6.65365C142.115 6.65688 142.115 6.6601 142.115 6.66333C150.611 9.44448 159.137 12.3768 166.466 14.8979C169.811 16.0482 172.906 17.1128 175.636 18.0384C191.479 23.4098 201.005 68.1348 204.669 99.0194C200.203 103.512 187.921 109.058 163.894 109.058C163.894 111.294 163.837 127.984 163.779 144.754L163.779 144.782L163.779 144.824C163.72 161.735 163.662 178.706 163.662 181H105.5H105.499H47.496C47.496 178.705 47.3841 161.815 47.2726 144.996L47.2726 144.99L47.2726 144.985C47.1621 128.31 47.0521 111.708 47.0521 109.472C23.0254 109.472 10.7958 103.512 6.33008 99.0194C9.99429 68.1348 19.5204 23.4098 35.3632 18.0384C38.0932 17.1129 41.1884 16.0483 44.5325 14.898L44.5326 14.898C52.1449 12.2797 61.047 9.21778 69.8671 6.34234C69.8669 6.30842 69.8669 6.27448 69.8669 6.24051Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9243 20.8486C16.7068 32.3761 8.60149 71.2811 5.27539 99.0208C9.50554 103.705 23.006 110.039 47.0916 110.094C46.4954 87.9577 46.3046 54.237 47.9672 51.2714L47.9838 51.2421C47.0134 43.3839 40.6626 34.0318 35.1383 26.823C33.3199 24.45 31.4566 22.6885 29.9243 20.8486Z",
    fill: "#9A9A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4056 119.723V120.263H47.4275C47.4202 120.085 47.4129 119.905 47.4056 119.723Z",
    fill: "#9A9A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.772 20.6211C194.272 31.3709 202.564 70.6401 205.89 98.3798C201.659 103.064 188.159 109.398 164.073 109.453C164.67 87.3167 164.86 53.5961 163.198 50.6304L163.181 50.6011C164.152 42.7429 170.502 33.3908 176.027 26.182C177.845 23.8091 179.24 22.4609 180.772 20.6211Z",
    fill: "#9A9A9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 119.082V119.622H163.738C163.745 119.444 163.752 119.264 163.759 119.082Z",
    fill: "#9A9A9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2321 17.4134C44.9221 14.0554 56.4614 9.89503 69.6946 5.86958C70.6853 5.55888 73.2424 4.9855 75.0311 5.86957C75.4416 13.2898 80.5376 18.927 87.1056 21.8127C78.5899 26.5884 58.8345 39.0725 47.9382 50.8031C46.2689 43.2551 36.3632 27.9233 29.6357 20.9753C31.3728 19.2272 33.2751 18.0916 35.2321 17.4134Z",
    fill: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.778 17.413C166.088 14.055 154.548 9.89468 141.315 5.86924C140.449 5.56837 137.977 5.06438 135.979 5.86922C135.568 13.2894 130.472 18.9267 123.904 21.8123C132.42 26.588 152.175 39.0722 163.072 50.8028C164.741 43.2547 174.647 27.923 181.374 20.9749C179.637 19.2269 177.735 18.0912 175.778 17.413Z",
    fill: "#191919"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6791 5.68649C72.862 4.9969 69.4081 5.54658 68.2246 6.29874C68.2246 21.4718 83.665 31.6134 105.279 31.6134C126.893 31.6134 142.161 21.6395 142.161 6.46648C140.914 5.21833 136.88 5.09831 135.483 5.59944C134.558 17.8165 123.197 24.3697 105.526 24.3697C87.8965 24.3697 76.6439 17.8465 75.6791 5.68649Z",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_564_13884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 20,
    width: 43,
    height: 100
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.772 20.6211C194.272 31.3709 202.564 70.6401 205.89 98.3798C201.659 103.064 188.159 109.398 164.073 109.453C164.67 87.3167 164.86 53.5961 163.198 50.6304L163.181 50.6011C164.152 42.7429 170.502 33.3908 176.027 26.182C177.845 23.8091 179.24 22.4609 180.772 20.6211Z",
    fill: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 119.082V119.622H163.738C163.745 119.444 163.752 119.264 163.759 119.082Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_564_13884)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96107,
    height: 81,
    transform: "matrix(0.832991 0.553286 0.553286 -0.832991 140.579 79.9668)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.96107,
    height: 81,
    transform: "matrix(0.832991 0.553286 0.553286 -0.832991 156.056 92.6758)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.96107,
    height: 81,
    transform: "matrix(0.832991 0.553286 0.553286 -0.832991 172.126 104.58)",
    fill: "#464646"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_564_13884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 20,
    width: 43,
    height: 101
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9243 20.8486C16.7068 32.3761 8.60149 71.2811 5.27539 99.0208C9.50554 103.705 23.006 110.039 47.0916 110.094C46.4954 87.9577 46.3046 54.237 47.9672 51.2714L47.9838 51.2421C47.0134 43.3839 40.6626 34.0318 35.1383 26.823C33.3199 24.45 31.4566 22.6885 29.9243 20.8486Z",
    fill: "#D3D3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4056 119.723V120.263H47.4275C47.4202 120.085 47.4129 119.905 47.4056 119.723Z",
    fill: "#D3D3D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_564_13884)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2402,
    y: 79.9668,
    width: 9.96106,
    height: 81,
    transform: "rotate(146.407 71.2402 79.9668)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7637,
    y: 92.6758,
    width: 9.96106,
    height: 81,
    transform: "rotate(146.407 55.7637 92.6758)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6934,
    y: 104.58,
    width: 9.96106,
    height: 81,
    transform: "rotate(146.407 39.6934 104.58)",
    fill: "#464646"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1054 110.636C23.0583 110.636 9.47706 104.121 5.0075 99.5916C4.60046 97.5243 5.04147 93.4461 6.08706 91.2666C11.7736 96.2857 28.9255 100.636 46.8464 101.155L47.1054 110.636Z",
    fill: "#191919"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.872 109.928C188.113 109.928 201.221 104.909 205.726 100.38C206.547 98.7231 206.136 93.3379 204.904 91.2666C199.172 96.2857 182.348 100.726 164.282 101.245L163.872 109.928Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmsG);
export default __webpack_public_path__ + "static/media/Arms G.12839cc83ca7e4f4bd2814e5b32f5700.svg";
export { ForwardRef as ReactComponent };